var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"youtube"},[_c('iframe',{attrs:{"src":("https://www.youtube.com/embed/" + _vm.srcKey)}})])}
var staticRenderFns = []

export { render, staticRenderFns }